module.exports = __webpack_public_path__ + "static/img/6.cf67050.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/6.png
// module id = Q7mb
// module chunks = 0